module.exports = __webpack_public_path__ + "static/media/undraw_empty_xct9.899bf6b4.svg";